"use client"

import Link from 'next/link'
import { ArrowRight, ExternalLink, TrendingUp } from 'lucide-react'
import MobileBlock from '@/components/mobile-block'

export default function HomePage() {
  return (
    <MobileBlock>
      <div className="fixed inset-0 min-h-screen w-full bg-gradient-to-b from-black via-gray-900 to-black">
      
      {/* Background Effect */}
      <div className="absolute inset-0 w-full overflow-hidden opacity-50">
        {/* Wave Background */}
        <div className="absolute inset-0 mt-0 blur-[10px] animate-slideUp opacity-0">
          <div id="wave" className="bg-wave"></div>
        </div>
      </div>
      
      {/* Grain Texture Overlay */}
      <div 
        className="absolute inset-0" 
        style={{
          backgroundImage: 'url(/grain.png)',
          backgroundSize: '100px 100px',
          backgroundRepeat: 'repeat',
          backgroundBlendMode: 'overlay',
          backgroundPosition: 'left top',
          mixBlendMode: 'overlay',
          opacity: 1
        }}
      />

      {/* Main Content */}
      <main className="relative min-h-screen w-full flex items-center justify-center px-4">
        <div className="container mx-auto max-w-5xl text-center">
          <div className="animate-slideUp">
            <div className="flex items-center justify-center mb-0">
              <img
                src="/migma-icon.svg"
                alt="Migma.ai Logo"
                className="object-contain"
                loading="eager"
                style={{
                  width: '170px',
                  height: 'auto',
                  filter: 'drop-shadow(0px -5px 136px black)'
                }}
              />
            </div>
            <h1 
              className="text-6xl md:text-8xl font-bold bg-gradient-to-r from-white via-white/90 to-white/60 bg-clip-text text-transparent mb-5 tracking-[-4px]"
              style={{
                lineHeight: '1.2'
              }}
            >
              Migma.ai
            </h1>
            {/* <p className="text-5xl text-white/70 mb-[90px] max-w-2xl mx-auto tracking-[-2px] leading-none">
              Prompt to inbox in seconds
            </p> */}
            
            {/* <div 
              className="border-t w-full my-28 mx-auto max-w-[900px]" 
              style={{
                borderImageSlice: 1,
                borderImageSource: 'radial-gradient(circle at 50% 0%, rgba(255, 255, 255, 0.5) 0%, rgba(252, 70, 107, 0) 100%)',
                margin: '30px auto'
              }}
            /> */}

            {/* Navigation Buttons */}
            <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-4 flex-wrap">
              <Link 
                href="https://migma.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-xl border border-white/20 bg-white/10 px-6 py-3 text-center backdrop-blur-sm hover:bg-white/15 hover:border-white/30 transition-all duration-300 hover:scale-105 min-w-[160px]"
              >
                <div className="flex items-center justify-center gap-2">
                  <span className="text-lg font-medium text-white">Visit Main Site</span>
                  <ExternalLink className="w-4 h-4 text-white/80" />
                </div>
              </Link>

              <Link 
                href="/pitchdeck"
                className="rounded-xl border border-white/20 bg-white/10 px-6 py-3 text-center backdrop-blur-sm hover:bg-white/15 hover:border-white/30 transition-all duration-300 hover:scale-105 min-w-[160px]"
              >
                <div className="flex items-center justify-center gap-2">
                  <span className="text-lg font-medium text-white">View Pitch Deck</span>
                  <ArrowRight className="w-4 h-4 text-white/80" />
                </div>
              </Link>

              <Link 
                href="/investors"
                className="rounded-xl border border-white/20 bg-white/10 px-6 py-3 text-center backdrop-blur-sm hover:bg-white/15 hover:border-white/30 transition-all duration-300 hover:scale-105 min-w-[160px]"
              >
                <div className="flex items-center justify-center gap-2">
                  <span className="text-lg font-medium text-white">Investor Updates</span>
                  <TrendingUp className="w-4 h-4 text-white/80" />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
    </MobileBlock>
  )
}
